import $$tracker from './index';
import { stReportSdk } from './report';

stReportSdk.trackPageLoad();
$$tracker.loadPageStart();
